module.exports = __webpack_public_path__ + "/images/shop/icon/product_label.svg";